var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetPassword3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 259,
    viewBox: "0 0 220 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_29635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.743 212.999L220.682 253.734C220.682 253.734 115.628 182.663 100.148 159.333C84.6676 136.003 95.6564 70.1032 95.6564 70.1032L147.184 88.1247L211.743 212.999Z",
    fill: "#FFC5C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0615 39.8594L44.8952 41.2043C44.8952 41.2043 37.4748 57.3435 60.4107 58.6884L59.0615 39.8594Z",
    fill: "#FFC5C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0615 64.7402L44.8952 66.0852C44.8952 66.0852 37.4748 82.2244 60.4107 83.5693L59.0615 64.7402Z",
    fill: "#FFC5C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0615 91.6406L44.8952 92.9855C44.8952 92.9855 37.4748 109.125 60.4107 110.47L59.0615 91.6406Z",
    fill: "#FFC5C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1084 118.539L48.9421 119.884C48.9421 119.884 41.5217 136.023 64.4575 137.368L63.1084 118.539Z",
    fill: "#FFC5C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1641 46.3434H53.239V16.9894C53.239 14.7583 53.6798 12.5491 54.5363 10.4878C55.3927 8.42658 56.6481 6.55368 58.2307 4.97608C59.8133 3.39847 61.692 2.14704 63.7598 1.29325C65.8275 0.439449 68.0437 1.70935e-06 70.2818 0H132.668C134.906 -4.55816e-06 137.123 0.439435 139.19 1.29323C141.258 2.14702 143.137 3.39844 144.719 4.97604C146.302 6.55365 147.557 8.42653 148.414 10.4878C149.27 12.549 149.711 14.7582 149.711 16.9893V178.028C149.711 180.259 149.27 182.468 148.414 184.53C147.557 186.591 146.302 188.464 144.719 190.041C143.137 191.619 141.258 192.87 139.19 193.724C137.123 194.578 134.906 195.018 132.668 195.018H70.2819C65.7618 195.018 61.4269 193.228 58.2307 190.042C55.0346 186.855 53.239 182.534 53.239 178.028V67.2382H52.1641V46.3434Z",
    fill: "#003482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5946 4.41994H77.7381C77.3636 5.3352 77.2207 6.32823 77.3218 7.31154C77.423 8.29485 77.7652 9.23827 78.3183 10.0587C78.8714 10.8791 79.6184 11.5513 80.4935 12.0162C81.3686 12.481 82.345 12.7242 83.3366 12.7242H119.077C120.069 12.7242 121.045 12.481 121.92 12.0162C122.795 11.5513 123.542 10.8791 124.095 10.0587C124.648 9.23828 124.991 8.29486 125.092 7.31154C125.193 6.32822 125.05 5.33519 124.675 4.41992H132.282C135.657 4.41992 138.894 5.75663 141.281 8.13598C143.668 10.5153 145.009 13.7424 145.009 17.1074V177.91C145.009 179.576 144.68 181.226 144.04 182.765C143.4 184.305 142.463 185.703 141.281 186.881C140.099 188.059 138.696 188.994 137.152 189.632C135.608 190.269 133.953 190.597 132.282 190.597H69.5946C67.9232 190.597 66.2682 190.269 64.724 189.632C63.1799 188.994 61.7768 188.059 60.595 186.881C59.4131 185.703 58.4756 184.305 57.836 182.765C57.1964 181.226 56.8672 179.576 56.8672 177.91V17.1074C56.8672 15.4412 57.1964 13.7914 57.836 12.2521C58.4756 10.7128 59.4131 9.31413 60.595 8.13599C61.7768 6.95786 63.1799 6.0233 64.724 5.3857C66.2682 4.7481 67.9232 4.41993 69.5946 4.41994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.369 49.4688H87.5078V55.9302H114.369V49.4688Z",
    fill: "#0067FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.647 77.2344H86.2285V83.6959H115.647V77.2344Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.769 91.1133H68.1094V97.5748H133.769V91.1133Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.769 104.994H68.1094V111.456H133.769V104.994Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.97 223.985L189.478 151.647L177.825 97.689L142.198 55.8945L130.922 37.3191C130.922 37.3191 112.617 42.4058 134.174 77.6771L143.84 96.8607C140.164 110.044 139.414 123.863 141.644 137.354L149.308 183.721C151.112 194.639 213.134 245.436 220.71 253.51L277.97 223.985Z",
    fill: "#FFC5C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.9708 41.001L44.8203 41.4082L53.1643 44.4722L53.3147 44.065L44.9708 41.001Z",
    fill: "#003482"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.9708 66.1651L44.8203 66.5723L53.1643 69.6363L53.3147 69.2291L44.9708 66.1651Z",
    fill: "#003482"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.9708 93.0655L44.8203 93.4727L53.1643 96.5366L53.3147 96.1295L44.9708 93.0655Z",
    fill: "#003482"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.3426 119.974L49.1543 120.365L53.2166 122.309L53.4049 121.918L49.3426 119.974Z",
    fill: "#003482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.972 167.218C111.363 167.218 119.787 158.82 119.787 148.462C119.787 138.103 111.363 129.705 100.972 129.705C90.5802 129.705 82.1562 138.103 82.1562 148.462C82.1562 158.82 90.5802 167.218 100.972 167.218Z",
    fill: "#0067FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.178 156.38L93.5469 149.161L96.8216 146.622L99.4879 150.04L108.496 140.561L111.508 143.405L99.178 156.38Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_29635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 259,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword3);
export default __webpack_public_path__ + "static/media/reset_password_3.070fb06deb27d0ce07ca97df4d10b325.svg";
export { ForwardRef as ReactComponent };